import { FC } from 'react';
import {
  useHashtagCoverImage,
  useHashtagDescription,
  useHashtagLinkPreviewTitle,
} from '@hashtag/shared/use-hashtag-tdk';

export const HashtagTwitter: FC = () => {
  const title = useHashtagLinkPreviewTitle();
  const description = useHashtagDescription();
  const cover = useHashtagCoverImage();

  return (
    <>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Lemon8" />
      <meta name="twitter:text:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={cover?.url || ''} />
    </>
  );
};
